<template>
  <div class="menu-tab-warp bg-white">
    <div class="menu-tab-left">
      <a-menu
        mode="inline"
        :style="{ border: '0', width: 'auto' }"
        :selectedKeys="[selectedTab]"
        type="inner"
        @click="handleTabMenuClick"
      >
        <a-menu-item key="changePassword">修改密码</a-menu-item>
      </a-menu>
    </div>
    <div class="menu-tab-right">
      <keep-alive>
        <ChangePassword v-if="selectedTab === 'changePassword'" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { ChangePassword } from './components'

export default {
  name: 'User.UserCenter',
  components: { ChangePassword },
  data () {
    return {
      selectedTab: 'changePassword'
    }
  },
  computed: {},
  methods: {
    handleTabMenuClick(data) {
      this.selectedTab = data.key
    }
  }
}
</script>

<style lang="less" scoped>
.menu-tab-warp {
  width: 100%;
  display: flex;
  // height: 100%;
  // overflow: auto;
  padding: 16px 0;

  .menu-tab-left {
    border-right: 1px solid #e8e8e8;
    width: 224px;

    .ant-menu-item {
      text-align: center;
    }
  }

  .menu-tab-right {
    flex: 1 1;
  }
}
</style>
